import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { BrandManagerTemplate } from 'components/Templates'

const BrandManager: FC = () => {
  return (
    <Layout iconPath={'/icon/white/home.svg'} headline={'ブランド管理'} title={'ブランド管理'}>
      <BrandManagerTemplate />
    </Layout>
  )
}
export default BrandManager
